export const getStringKeyFromLocalStorage = (key: string) =>
  localStorage.getItem(key) || "";

export function getEnumKeyFromLocalStorage<T>(key: string, defaultValue: T) {
  return (localStorage.getItem(key) || defaultValue) as T;
}

export const getBooleanKeyFromLocalStorage = (key: string): boolean =>
  localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key) || "false")
    : false;



// WEBPACK FOOTER //
// ./src/utils/localStorage.ts